import API_URLS from '../links';

export const getBatch = (creds, gymId) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_BATCHES + `/${gymId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const getProfile = (creds) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.GET_PROFILE, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addBatch = (creds, values) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_BATCH, {
        method: 'POST',
        headers: {
          access_token: creds.access_token,
          'content-type': 'application/json'
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const addGym = (creds, formData) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.ADD_GYM, {
        method: 'POST',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateGym = (creds, formData,id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_GYM +`/${id}`, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token
        },
        body: formData
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteBatch = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_BATCH + `/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const deleteGym = (creds, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.DELETE_GYM + `/${id}`, {
        method: 'DELETE',
        headers: {
          access_token: creds.access_token
        }
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};

export const updateBatch = (creds, values, id) => {
  return new Promise((resolve, reject) => {
    try {
      fetch(API_URLS.UPDATE_BATCH + `/${id}`, {
        method: 'PUT',
        headers: {
          access_token: creds.access_token,
          'content-type': 'application/json'
        },
        body: JSON.stringify(values)
      })
        .then((res) => res.json())
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (err) {
      reject(err);
    }
  });
};
